import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCode, FiCpu, FiCloudDrizzle } = FiIcons;

const pillars = [
  {
    icon: FiCode,
    title: "Custom Software Engineering",
    description: "Robust, scalable enterprise applications built primarily on .NET and modern web frameworks designed to handle complex business logic.",
    features: [".NET Development", "Web APIs", "Legacy Modernization"]
  },
  {
    icon: FiCpu,
    title: "AI & Intelligent Automation",
    description: "Integrating cutting-edge machine learning, deep learning, and computer vision to automate workflows and extract actionable insights.",
    features: ["Deep Learning", "Computer Vision", "Predictive Analytics"]
  },
  {
    icon: FiCloudDrizzle,
    title: "Cloud & Systems Integration",
    description: "Seamlessly connecting disparate systems and migrating architectures to Microsoft Azure for ultimate scalability and security.",
    features: ["Microsoft Azure", "Microservices", "API Gateways"]
  }
];

const Pillars = () => {
  return (
    <section id="expertise" className="py-24 relative z-10 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold mb-4 text-slate-900">Core Expertise</h2>
          <p className="text-slate-600 max-w-2xl mx-auto text-lg">
            We deliver end-to-end technology solutions that drive operational efficiency and competitive advantage.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {pillars.map((pillar, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              className="bg-white border border-slate-200 p-8 hover:border-cyan-300 transition-colors duration-300 group relative overflow-hidden shadow-sm hover:shadow-md"
            >
              {/* Subtle hover gradient */}
              <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-cyan-50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"></div>
              
              <div className="w-14 h-14 bg-slate-50 border border-slate-200 rounded-lg flex items-center justify-center mb-6 group-hover:border-cyan-300 transition-colors">
                <SafeIcon icon={pillar.icon} className="text-2xl text-cyan-600" />
              </div>
              
              <h3 className="text-xl font-bold text-slate-900 mb-4">{pillar.title}</h3>
              <p className="text-slate-600 mb-8 leading-relaxed">
                {pillar.description}
              </p>
              
              <ul className="space-y-2">
                {pillar.features.map((feature, fIndex) => (
                  <li key={fIndex} className="flex items-center gap-2 text-sm text-slate-700">
                    <div className="w-1.5 h-1.5 rounded-full bg-cyan-500"></div>
                    {feature}
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Pillars;